import { apiCall } from './gqlClient';
const GETALLUSERWORKOUTPLANS_QUERY = "\n  query getAllUserWorkoutPlans($userId: Int!) {\n    getAllUserWorkoutPlans(userId: $userId)\n    {\n      id\n\t\t\tproviderId\n\t\t\tuserId\n\t\t\tgroupId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tprice\n\t\t\tpublic\n\t\t\tnumberOfWeeks\n\t\t\tcurrentPlanNumberOfWeeks\n\t\t\timageId\n\t\t\tactive\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdateCreated\n\t\t\tpersonalPlan\n\t\t\tthumbnailUrl\n\t\t\tenrolled\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getAllUserWorkoutPlansApiCall = async function (_ref) {
  let {
    userId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETALLUSERWORKOUTPLANS_QUERY,
    variables: {
      userId
    },
    fragments
  });
};
const GETPROVIDERUSERSWORKOUTPLANS_QUERY = "\n  query getProviderUsersWorkoutPlans {\n    getProviderUsersWorkoutPlans\n    {\n      id\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tnumberOfWeeks\n\t\t\tprice\n\t\t\tactive\n\t\t\tuserId\n\t\t\tplanId\n\t\t\tplanTitle\n      ...fragments\n    }\n  }";
export const getProviderUsersWorkoutPlansApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETPROVIDERUSERSWORKOUTPLANS_QUERY,
    variables: {},
    fragments
  });
};
const GETMYGROUPEDWORKOUTPLANS_QUERY = "\n  query getMyGroupedWorkoutPlans {\n    getMyGroupedWorkoutPlans\n    {\n      id\n\t\t\tproviderId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tprice\n\t\t\tpublic\n\t\t\tnumberOfWeeks\n\t\t\timageId\n\t\t\tactive\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdateCreated\n\t\t\tthumbnailUrl\n      ...fragments\n    }\n  }";
export const getMyGroupedWorkoutPlansApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETMYGROUPEDWORKOUTPLANS_QUERY,
    variables: {},
    fragments
  });
};
const GETMYWORKOUTPLANS_QUERY = "\n  query getMyWorkoutPlans {\n    getMyWorkoutPlans\n    {\n      id\n\t\t\tproviderId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tprice\n\t\t\tpublic\n\t\t\tnumberOfWeeks\n\t\t\timageId\n\t\t\tactive\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdateCreated\n\t\t\tthumbnailUrl\n      ...fragments\n    }\n  }";
export const getMyWorkoutPlansApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETMYWORKOUTPLANS_QUERY,
    variables: {},
    fragments
  });
};
const GETUSERWORKOUTPLANDETAILS_QUERY = "\n  query getUserWorkoutPlanDetails($workoutPlanId: String!, $userId: Int, $groupId: Int) {\n    getUserWorkoutPlanDetails(workoutPlanId: $workoutPlanId, userId: $userId, groupId: $groupId)\n    {\n      id\n\t\t\tproviderId\n\t\t\tuserId\n\t\t\tgroupId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tprice\n\t\t\tpublic\n\t\t\tnumberOfWeeks\n\t\t\tcurrentPlanNumberOfWeeks\n\t\t\timageId\n\t\t\tactive\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdateCreated\n\t\t\tpersonalPlan\n\t\t\tthumbnailUrl\n\t\t\tenrolled\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getUserWorkoutPlanDetailsApiCall = async function (_ref2) {
  let {
    workoutPlanId,
    userId,
    groupId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERWORKOUTPLANDETAILS_QUERY,
    variables: {
      workoutPlanId,
      userId,
      groupId
    },
    fragments
  });
};
const GETMYWORKOUTPLANDETAILS_QUERY = "\n  query getMyWorkoutPlanDetails($workoutPlanId: String!, $groupId: Int) {\n    getMyWorkoutPlanDetails(workoutPlanId: $workoutPlanId, groupId: $groupId)\n    {\n      id\n\t\t\tproviderId\n\t\t\tuserId\n\t\t\tgroupId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tprice\n\t\t\tpublic\n\t\t\tnumberOfWeeks\n\t\t\tcurrentPlanNumberOfWeeks\n\t\t\timageId\n\t\t\tactive\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdateCreated\n\t\t\tpersonalPlan\n\t\t\tthumbnailUrl\n\t\t\tenrolled\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getMyWorkoutPlanDetailsApiCall = async function (_ref3) {
  let {
    workoutPlanId,
    groupId
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETMYWORKOUTPLANDETAILS_QUERY,
    variables: {
      workoutPlanId,
      groupId
    },
    fragments
  });
};
const GETUSERWORKOUTDETAILS_QUERY = "\n  query getUserWorkoutDetails($id: String!) {\n    getUserWorkoutDetails(id: $id)\n    {\n      id\n\t\t\tproviderId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tlevel\n\t\t\tdateCreated\n\t\t\timageId\n\t\t\tthumbnailUrl\n\t\t\tprice\n\t\t\tactive\n      ...fragments\n    }\n  }";
export const getUserWorkoutDetailsApiCall = async function (_ref4) {
  let {
    id
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERWORKOUTDETAILS_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const GETALLUSERWORKOUTS_QUERY = "\n  query getAllUserWorkouts {\n    getAllUserWorkouts\n    {\n      id\n\t\t\tproviderId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tlevel\n\t\t\tdateCreated\n\t\t\timageId\n\t\t\tthumbnailUrl\n\t\t\tprice\n\t\t\tactive\n\t\t\tpersonalPlan\n      ...fragments\n    }\n  }";
export const getAllUserWorkoutsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETALLUSERWORKOUTS_QUERY,
    variables: {},
    fragments
  });
};
const GETALLNOTASSIGNEDUSERSFORPLAN_QUERY = "\n  query getAllNotAssignedUsersForPlan($id: String!) {\n    getAllNotAssignedUsersForPlan(id: $id)\n  }";
export const getAllNotAssignedUsersForPlanApiCall = async _ref5 => {
  let {
    id
  } = _ref5;
  return apiCall({
    query: GETALLNOTASSIGNEDUSERSFORPLAN_QUERY,
    variables: {
      id
    }
  });
};
const GETALLNOTASSIGNEDGROUPSFORPLAN_QUERY = "\n  query getAllNotAssignedGroupsForPlan($id: String!) {\n    getAllNotAssignedGroupsForPlan(id: $id)\n  }";
export const getAllNotAssignedGroupsForPlanApiCall = async _ref6 => {
  let {
    id
  } = _ref6;
  return apiCall({
    query: GETALLNOTASSIGNEDGROUPSFORPLAN_QUERY,
    variables: {
      id
    }
  });
};
const GETUSERWORKOUTPLANDATES_QUERY = "\n  query getUserWorkoutPlanDates($templatePlanId: String!, $userId: Int!, $ignorePlanId: String) {\n    getUserWorkoutPlanDates(templatePlanId: $templatePlanId, userId: $userId, ignorePlanId: $ignorePlanId)\n  }";
export const getUserWorkoutPlanDatesApiCall = async _ref7 => {
  let {
    templatePlanId,
    userId,
    ignorePlanId
  } = _ref7;
  return apiCall({
    query: GETUSERWORKOUTPLANDATES_QUERY,
    variables: {
      templatePlanId,
      userId,
      ignorePlanId
    }
  });
};
const CHECKIFPLANSHOULDUPDATEFROMCURRENTCONFIG_QUERY = "\n  query checkIfPlanShouldUpdateFromCurrentConfig($userPlanId: String!) {\n    checkIfPlanShouldUpdateFromCurrentConfig(userPlanId: $userPlanId)\n  }";
export const checkIfPlanShouldUpdateFromCurrentConfigApiCall = async _ref8 => {
  let {
    userPlanId
  } = _ref8;
  return apiCall({
    query: CHECKIFPLANSHOULDUPDATEFROMCURRENTCONFIG_QUERY,
    variables: {
      userPlanId
    }
  });
};
const CREATEUSERWORKOUTPLAN_QUERY = "\n  mutation createUserWorkoutPlan($request: UserWorkoutPlanInput!) {\n    createUserWorkoutPlan(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createUserWorkoutPlanApiCall = async function (_ref9) {
  let {
    request
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEUSERWORKOUTPLAN_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATEUSERWORKOUTPLANFROMCURRENTPLANCONFIGURATION_QUERY = "\n  mutation updateUserWorkoutPlanFromCurrentPlanConfiguration($userPlanId: String!, $startTime: DateTime!) {\n    updateUserWorkoutPlanFromCurrentPlanConfiguration(userPlanId: $userPlanId, startTime: $startTime)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateUserWorkoutPlanFromCurrentPlanConfigurationApiCall = async function (_ref0) {
  let {
    userPlanId,
    startTime
  } = _ref0;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEUSERWORKOUTPLANFROMCURRENTPLANCONFIGURATION_QUERY,
    variables: {
      userPlanId,
      startTime
    },
    fragments
  });
};
const CREATEUSERWORKOUTPLANBYGROUP_QUERY = "\n  mutation createUserWorkoutPlanByGroup($request: UserWorkoutPlanInput!) {\n    createUserWorkoutPlanByGroup(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createUserWorkoutPlanByGroupApiCall = async function (_ref1) {
  let {
    request
  } = _ref1;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEUSERWORKOUTPLANBYGROUP_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const ASSIGNFREEUSERWORKOUTPLAN_QUERY = "\n  mutation assignFreeUserWorkoutPlan($id: String!) {\n    assignFreeUserWorkoutPlan(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const assignFreeUserWorkoutPlanApiCall = async function (_ref10) {
  let {
    id
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ASSIGNFREEUSERWORKOUTPLAN_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const UNASSIGNFREEUSERWORKOUTPLAN_QUERY = "\n  mutation unassignFreeUserWorkoutPlan($id: String!) {\n    unassignFreeUserWorkoutPlan(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const unassignFreeUserWorkoutPlanApiCall = async function (_ref11) {
  let {
    id
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UNASSIGNFREEUSERWORKOUTPLAN_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const UPDATEUSERWORKOUTPLAN_QUERY = "\n  mutation updateUserWorkoutPlan($request: UserWorkoutPlanUpdateInput!) {\n    updateUserWorkoutPlan(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateUserWorkoutPlanApiCall = async function (_ref12) {
  let {
    request
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEUSERWORKOUTPLAN_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CREATEUSERCIRCUIT_QUERY = "\n  mutation createUserCircuit($request: UserCircuitInput!) {\n    createUserCircuit(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createUserCircuitApiCall = async function (_ref13) {
  let {
    request
  } = _ref13;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEUSERCIRCUIT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATEUSERCIRCUIT_QUERY = "\n  mutation updateUserCircuit($request: UserCircuitUpdateInput!) {\n    updateUserCircuit(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateUserCircuitApiCall = async function (_ref14) {
  let {
    request
  } = _ref14;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEUSERCIRCUIT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CREATEUSERCIRCUITEQUIPMENT_QUERY = "\n  mutation createUserCircuitEquipment($request: UserCircuitEquipmentInput!) {\n    createUserCircuitEquipment(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createUserCircuitEquipmentApiCall = async function (_ref15) {
  let {
    request
  } = _ref15;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEUSERCIRCUITEQUIPMENT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATEUSERCIRCUITEQUIPMENT_QUERY = "\n  mutation updateUserCircuitEquipment($request: UserCircuitEquipmentInput!) {\n    updateUserCircuitEquipment(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateUserCircuitEquipmentApiCall = async function (_ref16) {
  let {
    request
  } = _ref16;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEUSERCIRCUITEQUIPMENT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CHANGEUSERWORKOUTPLANSTATUS_QUERY = "\n  mutation changeUserWorkoutPlanStatus($id: String!, $active: Boolean!) {\n    changeUserWorkoutPlanStatus(id: $id, active: $active)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const changeUserWorkoutPlanStatusApiCall = async function (_ref17) {
  let {
    id,
    active
  } = _ref17;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEUSERWORKOUTPLANSTATUS_QUERY,
    variables: {
      id,
      active
    },
    fragments
  });
};
const CHANGEUSERWORKOUTSCHEDULE_QUERY = "\n  mutation changeUserWorkoutSchedule($request: UserWorkoutScheduleInput!) {\n    changeUserWorkoutSchedule(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const changeUserWorkoutScheduleApiCall = async function (_ref18) {
  let {
    request
  } = _ref18;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEUSERWORKOUTSCHEDULE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CHANGEUSERPLANSTARTENDTIME_QUERY = "\n  mutation changeUserPlanStartEndTime($id: String!, $startTime: DateTime!, $endTime: DateTime!, $userId: Int, $groupId: Int) {\n    changeUserPlanStartEndTime(id: $id, startTime: $startTime, endTime: $endTime, userId: $userId, groupId: $groupId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const changeUserPlanStartEndTimeApiCall = async function (_ref19) {
  let {
    id,
    startTime,
    endTime,
    userId,
    groupId
  } = _ref19;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEUSERPLANSTARTENDTIME_QUERY,
    variables: {
      id,
      startTime,
      endTime,
      userId,
      groupId
    },
    fragments
  });
};